/* eslint-disable */
// GENERATED by scripts/longevity-images.py — do not edit by hand.
// Re-run `npm run longevity:images` after changing a source capture.

import daily_360 from './daily-360.webp';
import daily_540 from './daily-540.webp';
import daily_720 from './daily-720.webp';
import daily_1080 from './daily-1080.webp';
import daily_crop_360 from './daily-crop-360.webp';
import daily_crop_540 from './daily-crop-540.webp';
import daily_crop_720 from './daily-crop-720.webp';
import daily_crop_1080 from './daily-crop-1080.webp';
import sleep_360 from './sleep-360.webp';
import sleep_540 from './sleep-540.webp';
import sleep_720 from './sleep-720.webp';
import sleep_1080 from './sleep-1080.webp';
import review_360 from './review-360.webp';
import review_540 from './review-540.webp';
import review_720 from './review-720.webp';
import review_1080 from './review-1080.webp';
import widget_steps_300 from './widget-steps-300.webp';
import widget_steps_450 from './widget-steps-450.webp';
import widget_steps_537 from './widget-steps-537.webp';
import widget_steps_lockscreen_400 from './widget-steps-lockscreen-400.webp';
import widget_steps_lockscreen_800 from './widget-steps-lockscreen-800.webp';
import widget_steps_lockscreen_1206 from './widget-steps-lockscreen-1206.webp';

const images = {
  'daily': {
    width: 1206,
    height: 2622,
    src: daily_1080,
    srcSet: `${daily_360} 360w, ${daily_540} 540w, ${daily_720} 720w, ${daily_1080} 1080w`,
  },
  'daily-crop': {
    width: 1206,
    height: 1187,
    src: daily_crop_1080,
    srcSet: `${daily_crop_360} 360w, ${daily_crop_540} 540w, ${daily_crop_720} 720w, ${daily_crop_1080} 1080w`,
  },
  'sleep': {
    width: 1206,
    height: 2622,
    src: sleep_1080,
    srcSet: `${sleep_360} 360w, ${sleep_540} 540w, ${sleep_720} 720w, ${sleep_1080} 1080w`,
  },
  'review': {
    width: 1206,
    height: 2622,
    src: review_1080,
    srcSet: `${review_360} 360w, ${review_540} 540w, ${review_720} 720w, ${review_1080} 1080w`,
  },
  'learn': null,
  'widget-checklist': null,
  'widget-steps': {
    width: 537,
    height: 535,
    src: widget_steps_537,
    srcSet: `${widget_steps_300} 300w, ${widget_steps_450} 450w, ${widget_steps_537} 537w`,
  },
  'widget-steps-lockscreen': {
    width: 1206,
    height: 698,
    src: widget_steps_lockscreen_1206,
    srcSet: `${widget_steps_lockscreen_400} 400w, ${widget_steps_lockscreen_800} 800w, ${widget_steps_lockscreen_1206} 1206w`,
  },
};

export default images;
